import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  readonly forbiddenDates: Date[] = [
    new Date(2024, 5, 7), // Viernes 7 de junio
    new Date(2024, 5, 29), // Sábado 29 de junio
    new Date(2024, 6, 23), // Martes 23 de julio
    new Date(2024, 6, 28), // Domingo 28 de julio
    new Date(2024, 6, 29), // Lunes 29 de julio
    new Date(2024, 7, 6), // Martes 6 de agosto
    new Date(2024, 7, 30), // Viernes 30 de agosto
    new Date(2024, 9, 8), // Martes 8 de octubre
    new Date(2024, 10, 1), // Viernes 1 de noviembre
    new Date(2024, 11, 8), // Domingo 8 de diciembre
    new Date(2024, 11, 9), // Lunes 9 de diciembre
    new Date(2024, 11, 25), // Miércoles 25 de diciembre
    // Año 2025
    new Date(2025, 3, 17), // 17 de abril
    new Date(2025, 3, 18), // 18 de abril
    // Año 2026
    new Date(2026, 3, 2), // 02 de abril
    new Date(2026, 3, 3), // 03 de abril
    // Año 2027
    new Date(2027, 2, 25), // 25 de marzo
    new Date(2027, 2, 26), // 26 de marzo
  ];

  private readonly url = environment.apiURL;
  constructor(
    private readonly _http: HttpClienteService,
    private readonly http: HttpClient,
    ) { }

  setOrder(data: any){
    const query = `${this.url}/wcl-order/order-save-v2`
    return this._http.post(query, data);
  }
  getOrders(data: any){
    let query = `${this.url}/wcl-order/history-order-list?code=${data.code}&sector=${data.sector}`
    if (data.month) { query += `&month=${data.month}`; }
    if (data.year) { query += `&year=${data.year}`; }
    return this._http.get(query);
  }
  getOrderPeriods(months: number = 3){
    const query = `${this.url}/wcl-document/get-month?months=${months}`
    return this._http.get(query);
  }
  /** Data (JSON) del historial para armar el Excel en el front. */
  downloadOrderHistory(data: any): Observable<any> {
    const query = `${this.url}/wcl-order/history-order-download?code=${data.code}&sector=${data.sector}`
    return this._http.get(query);
  }
  /** Archivos (banners) por filtros. Mismo endpoint que Aliados; module = "HistorialCompras". */
  getBlobFilesByFilters(payload: any){
    const query = `${this.url}/wcl-customer/blob-files-list-by-filters`
    return this._http.post(query, payload);
  }
  getOrderHistoryDetails(id: string){
    const query = `${this.url}/wcl-order/history-order-detail?sapDocument=${id}`
    return this._http.get(query);
  }

  suggestedProduct(data: any){
    //const query = `${this.url}/wcl-order/validate-stock`
    const query = `${this.url}/wcl-order/suggested-products-by-customer-code`
    return this._http.post(query, data)
  }
  orderPrice(data: any){
    const query = `${this.url}/wcl-order/order-price `
    return this._http.post(query, data)
  }
  newCheckStock(data: any){
    const query = `${this.url}/wcl-order/order-stock-management?code=${data.code}&sector=${data.sector}&products=${data.products}`
    return this._http.get(query);
  }
  orderEdit(data:any){
    const query = `${this.url}/wcl-order/order-edit`
    return this._http.put(query, data)
  }
}
